var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ManageUsersGroupsCreateUser',{attrs:{"UG":_vm.UG,"accessRoles":_vm.accessRoles},on:{"save":function($event){return _vm.save({edit: false})}}})
}
var staticRenderFns = []

export { render, staticRenderFns }